// components/ProductSelector.jsx
import React, { createRef, useRef, useState } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import PropTypes from 'prop-types';
import useHandleAddProduct from '../../utils/handleAddProduct';
// import CustomButton from '../../components/general/button';
import { setDailyDonationStatus } from '../../utils/setDailyDonationStatus';
// import ShowCurrencies from '../../utils/showCurrencies';
import getSymbolFromCurrency from 'currency-symbol-map';

const ProductSelector = ({ products, selectedProducts, setSelectedProducts, currency }) => {
    // Local state to track input quantities for products not yet selected
    const [inputQuantities, setInputQuantities] = useState({});
    const [addProduct, editProduct, removeProduct] = useHandleAddProduct();
    const refQuantity = useRef(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'].map(() => createRef()));
    // Handler for toggling product selection
    const handleToggleSelect = (productId, value) => {
        if (selectedProducts.some((p) => p.id === productId)) {
            // Deselect product
            setSelectedProducts(selectedProducts.filter((p) => p.id !== productId));
        } else {
            // Select product with entered quantity or default
            const product = products.find((p) => p.id === productId);
            // const enteredQuantity = inputQuantities[productId];
            const enteredQuantity = value;
            if (!enteredQuantity || enteredQuantity <= 0) {
                // Do not add the product if quantity is 0 or not entered
                return;
            }
            const quantity = enteredQuantity;
            addProduct({ product: product, currency: currency, justAddToLocalStorage: true });
            setSelectedProducts([...selectedProducts, { ...product, quantity }]);
            // Clear inputQuantities for this product
            setInputQuantities((prev) => {
                const newInputs = { ...prev };
                delete newInputs[productId];
                return newInputs;
            });
        }
    };

    // Handler for changing donation quantity when product is selected
    const handleQuantityChange = (productId, quantity,index) => {
        const numQuantity = Number(quantity);
        refQuantity.current[index].current.value = '';
        if (isNaN(numQuantity) || numQuantity <= 0 || quantity === '') {
            // Deselect product
            setSelectedProducts(selectedProducts.filter((p) => p.id !== productId));
        } else {
            const sanitizedQuantity = Math.floor(numQuantity);
            const isSelected = selectedProducts.some((p) => p.id === productId);
            if (isSelected) {
                setSelectedProducts(
                    selectedProducts.map((p) =>
                        p.id === productId ? { ...p, quantity: sanitizedQuantity } : p
                    )
                );
            } else {
                setInputQuantities(
                    {
                        ...inputQuantities,
                        [productId]: sanitizedQuantity,
                    }
                );
                handleToggleSelect(productId, sanitizedQuantity)
            }
        }
    };

    const handleKeyDown = value => {
        let checkIfNum;
        if (value.key !== undefined) {
            checkIfNum = value.key === '.';
        }
        return checkIfNum && value.preventDefault();
    };
    // const handleOnBlurQty = (productId,value,index) => {
    //     if (Number(value) === 0) {
    //         handleQuantityChange(productId,1,index);
    //     }
    // };
    return (
        <div className="w-full">
            {products.filter(product => Number(product.status) === 1).map((product,index) => {
                const selectedProduct = selectedProducts.find((p) => p.id === product.id);
                return (
                    <div key={product.id} className="flex flex-col sm:flex-row w-full py-2">
                        <div className="flex justify-center w-full sm:w-1/4 lg:w-1/5 mb-3 sm:mb-0">
                            {product.image_link ? (
                                <LazyLoadImage
                                    alt={product.name}
                                    effect="blur"
                                    width={`100%`}
                                    delayTime={500}
                                    className={`cursor-pointer block rounded-md`}
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = '/images/general/logo-replace.png';
                                    }}
                                    src={product.image_link} // use normal <img> attributes as props
                                />
                            ) : (
                                <img className={`w-full`} src="/images/general/logo-replace.png" alt="" />
                            )}
                            {/* <img className={`w-full max-w-[200px] mx-auto`} src="/images/general/logo-replace.png" alt="" /> */}
                        </div>
                        <div className="flex flex-col justify-center w-full sm:w-3/4 lg:w-4/5 sm:px-4">
                            <h2 className="text-[#253B7E] font-bold text-lg xl:text-xl mb-1">{product.name}</h2>
                            <p dangerouslySetInnerHTML={{ __html: product.short_description || product.description }} className={`text-stone-500 font-normal text-sm md:text-base`}></p>
                            <div className="flex justify-between mt-2 md:mt-4 rounded-md border border-[#78716C] lg:w-2/5 pl-2 items-center overflow-hidden">
                                {/* {ShowCurrencies(currency, selectedProduct && selectedProduct.quantity ? selectedProduct.quantity : '')} */}
                                {selectedProduct && selectedProduct.quantity && getSymbolFromCurrency(currency.toLowerCase())}
                                <input
                                    ref={refQuantity.current[index]}
                                    className='px-1 h-12 w-full focus:outline-none'
                                    type="number"
                                    id={`quantity-${product.id}`}
                                    min="0" // Changed from min="1" to min="0"
                                    step="1"
                                    value={selectedProduct && selectedProduct.quantity ? selectedProduct.quantity : ''}
                                    onChange={(e) => {
                                        const rawValue = e.target.value;

                                        // Remove all non-digit characters
                                        let validatedValue = rawValue.replace(/[^0-9]/g, '');

                                        // Remove ALL leading zeros (e.g., "0054" → "54")
                                        validatedValue = validatedValue.replace(/^0+/, '') || '0';

                                        // If the user clears the input, allow it
                                        if (rawValue === '') {
                                            validatedValue = '';
                                        }

                                        // Update state
                                        setDailyDonationStatus();
                                        console.log("on changes before=", validatedValue)
                                        if (parseInt(validatedValue) > 0) {
                                            validatedValue = parseInt(validatedValue);
                                        } else {
                                            validatedValue = 0;
                                        }
                                        handleQuantityChange(product.id, validatedValue,index);
                                    }}
                                    onKeyDown={e => handleKeyDown(e)}
                                    // onBlur={e => handleOnBlurQty(product.id,e.target.value,index)}
                                    placeholder="Enter Amount"
                                />
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

// PropTypes for type checking
ProductSelector.propTypes = {
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedProducts: PropTypes.arrayOf(PropTypes.object).isRequired,
    setSelectedProducts: PropTypes.func.isRequired,
    currency: PropTypes.string.isRequired,
};

export default ProductSelector;
